import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';

import { T } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { Explain } from '@flipster/react/design-utils/explain';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { tpslModalInputBunja } from '../../state';
import { tpslModalValidationBunja } from '../../validation';
import { LimitPriceInput } from './limit-price-input';
import { LimitPriceRateButtons } from './limit-price-rate-buttons';

export const SetLimitPriceSection = () => {
  const { isBboAtom, limitPriceInputErrorMessageAtom } = useBunja(setLimitPriceSectionBunja);
  const [isBbo, setIsBbo] = useAtom(isBboAtom);
  const limitPriceInputErrorMessage = useAtomValue(limitPriceInputErrorMessageAtom);

  return (
    <section
      className={stack({
        px: 16,
        py: 12,
        gap: 4,
        rounded: 8,
        bg: 'background.default.level-1',
      })}
    >
      <div className={hstack({ justify: 'space-between', alignItems: 'center' })}>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-5' })}>
          <T id='Trade.r260420.Limit_price' />
        </p>
        <Checkbox checked={isBbo} onChange={(e) => setIsBbo(e.target.checked)}>
          <span className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-5' })}>
            <T id='Autogen_common.r251126.s_BBO' />
          </span>
        </Checkbox>
      </div>
      <div className={stack({ gap: 12 })}>
        {isBbo ? (
          <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5' })}>
            <T id='Trade.r260420.Best_counterparty' />
          </p>
        ) : (
          <>
            <LimitPriceInput />
            <LimitPriceRateButtons />
          </>
        )}
        {limitPriceInputErrorMessage ? (
          <Explain.Error>{limitPriceInputErrorMessage}</Explain.Error>
        ) : (
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>
            {isBbo ? <T id='Trade.r260420.Limit_tp_sl_bbo_desc' /> : <T id='Trade.r260420.Limit_tp_sl_disclaimer' />}
          </p>
        )}
      </div>
    </section>
  );
};

const setLimitPriceSectionBunja = bunja(() => {
  const { isBboAtom } = bunja.use(tpslModalInputBunja);
  const { limitPriceInputErrorMessageAtom } = bunja.use(tpslModalValidationBunja);
  return { isBboAtom, limitPriceInputErrorMessageAtom };
});
setLimitPriceSectionBunja.debugLabel = 'setLimitPriceSectionBunja';
